import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from '../../../layout/header/header.component';
import {
  ConfirmEventType,
  ConfirmationService,
  Message,
  MessageService,
  SelectItem,
  TreeNode,
} from 'primeng/api';
import { Table } from 'primeng/table';
import { DataService } from 'src/app/services/data.service';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-role-interface',
  templateUrl: './role-interface.component.html',
  styleUrls: ['./role-interface.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class RoleInterfaceComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  @ViewChild('dt')
  dt!: Table;

  messages: Message[] = [];
  translator:TranslatorPipe = new TranslatorPipe()

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];

  treedata: TreeNode[] = [];
  header = 'إدارة الواجهات';
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-chevron-circle-right',
      link: '/admin/users/roles',
      visible:this.permissionService.hasPermission('ROLE_MANAGEMENT','r')
    },
    {
      name: 'الصلاحيات',
      icon: 'pi pi-shield',
      link: '/admin/users/roles/permission',
      visible:this.permissionService.hasPermission('PERMISSION_MANAGEMENT','r')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('User console'), link: '/admin/users' },
    { name: this.translate('Organizing roles'), link: '/admin/users/roles' },
    // { name: 'إدارة الواجهات', link: '/admin/users/roles/interface' },
  ];
  stats: stat[] = [];

  interfaceData: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService:PermissionHandlerService
  ) {}

  ngOnInit() {
    this.getInterfaces().then((e) => {
      this.skelition = false;
    });
    this.makequestion();
  }


  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  // Add New Interface

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'اسم الواجهة',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value:true,
        visibility:"false"
      }),
    ];
  }

  private updateInterfaceCount(): void {
    let activePositions = this.data.filter(
      (item: any) => item['الحالة'].n === true
    ).length;
    let inactivePositions = this.data.length - activePositions;
    this.stats = [
      {
        name: this.translate('active'),
        number: activePositions,
        icon: 'pi pi-check-circle',
      },
      {
        name: this.translate('Inactive'),
        number: inactivePositions,
        icon: 'pi pi-times-circle',
      },
    ];
    console.log('Updating stats', this.stats);
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData('role/interface/', data);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();

      console.log('=Test==>', res.data.data);
      this.interfaceData.push(res.data.data);
      this.data.unshift({
        '#': { n: res.data.data._id, i: 'pi pi-angle-left' },
        'اسم الواجهة': { n: data.name, i: 'pi pi-' + data.icon },
        'الحالة': {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
        },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updateInterfaceCount();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'role/interface/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['#'] = { n: data._id, i: 'pi pi-angle-left' }),
          (myObject['اسم الواجهة'].n = data.name),
          (myObject['اسم الواجهة'].i = data.icon);
        myObject['الحالة'].n = data.active;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
      }
      this.data.map((e, i) => {
        if (e['#'].n == data._id) {
          this.data[i] = myObject;
        }
      });
      this.interfaceData.map((e, i) => {
        if (e._id == data._id) {
          this.interfaceData[i] = data;
        }
      });
      this.updateInterfaceCount();
    } catch (error) {
      console.log(error);
    }
  };

  // Add Table Configuration
  getInterfaces = async () => {
    try {
      let res = await this.dataService.postData('role/interface/get/', {});
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.interfaceData = res.data.data;
      this.interfaceData.forEach((item: any) => {
        console.log('Console..Item =>', item);
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم الواجهة': { n: item.name, i: 'pi pi-' + item.icon },
          'الحالة': {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateInterfaceCount();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteInterface($event.id),
        });
        break;
      case 'Update':
        this.updateData = this.interfaceData.find(
          (item) => item._id == $event.id
        );
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم الواجهة',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-12',
          }),
          new DropdownQuestion({
            key: 'active',
            label: 'الحالة',
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-12',
          }),
        ];
        // console.log("Update Data ==>",this.interfaceData,this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }
  deleteInterface = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`role/interface/?id=${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.interfaceData = this.interfaceData.filter((item) => item._id !== id);
      this.updateInterfaceCount();
    } catch (error) {
      console.log(error);
    }
  };
  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel:'نعم',
      rejectLabel:'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
